/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractCancelResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }],
} as const;
